import { EventEmitter } from "eventemitter3";
import DataStore, { DATA_STORE } from "../DataStore";

export default class EmptyResult extends EventEmitter {
  constructor(container, imagesByCat) {
    super();
    // special case: empty search result
    const cats = imagesByCat;
    const keys = Object.keys(cats);

    const element = document.createElement("div");
    container.appendChild(element);

    console.log("Content.js : empty search result", cats);

    const msg =
      "<br><br>Sorry, we could not find any images using your search term, either try again or click below to explore more of the archive.<br>";
    const headline = document.createElement("h2");
    headline.classList.add("searchMessage");
    headline.innerHTML =
      keys[0].split("/").join("<br/>").slice(5).toUpperCase() + msg;
    element.appendChild(headline);

    let parent = document.createElement("div");
    element.appendChild(parent);

    const DICT = {};
    DATA_STORE.categoriesList.forEach((cat) => {
      if (cat.lastIndexOf("Internet") != -1) return;
      if (cat == "/Sensitive Subjects") return;
      if (cat == "/Adult") return;
      const root = cat.split("/")[1];
      if (DICT[root] === undefined) {
        DICT[root] = [];
      }
      if (cat.split("/").length > 2) {
        DICT[root].push(cat);
      }
    });

    for (let key in DICT) {
      let link = document.createElement("a");
      link.classList.add("catagory-link");
      link.innerText = key;
      link.addEventListener("pointerup", () => {
        let candidates = [];
        DICT[key].forEach((name) => {
          candidates = candidates.concat(DATA_STORE.categories[name]);
        });
        const total = candidates.length;
        console.log(total);

        const assets = [];
        for (let i = 0; i < total; i++) {
          const cn = DICT[key][~~(Math.random() * DICT[key].length)];
          const ar = DATA_STORE.categories[cn];
          let na = ar[~~(Math.random() * ar.length)];
          assets.push(na);
        }
        this.emit("select", key, assets);
      });
      parent.appendChild(link);
    }
  }
}
